import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import { useSearchParams } from 'react-router-dom';
import { useGetAssetsMutation } from '@/app/Crawl/api/detailsApi';
import {
  altColumn,
  protocolColumn,
  ps_urlColumn,
  size_KBColumn,
  status_codeColumn
} from '../../../config/columns';
import { useGetUserInfoQuery } from '@/app/common/api/authApi';
import { Col, Row } from 'react-bootstrap';
import FiltersComponent from '@/app/common/components/filters/FiltersComponent';
import { decoder } from '@/helpers/utils';
import useDomain from '@/hooks/useDomain';
// نمایش تصویر ها در فهرست بازبینی

const Img = () => {
  const [searchParams] = useSearchParams();
  const { domain_slug } = useDomain();
  useGetUserInfoQuery();
  const [getAssets] = useGetAssetsMutation(
    {
      body: { job_page: searchParams.get('job_page') }
    } as never
  );
  // تنظیم ستون ها به حالت تمام کامل
  const columns = [
    ps_urlColumn({
      details: 'assets_all',
      activeTab: 'assets_all',
      type: 'image'
    }),
    altColumn,
    protocolColumn,
    status_codeColumn,
    size_KBColumn
  ].map(col => ({ ...col, flex: 1 }));

  return (
    <Row className="mt-5">
      <Col md={12}>
        <FiltersComponent
          columns={columns}
          preQueries={searchParams.toString()}
        />
      </Col>
      <Col md={12}>
        <AgGridWrapper
          fetchFunction={getAssets}
          height="746px"
          columns={columns}
           
          additionalData={{
            job_page: searchParams.get('job_page'),
            domain_slug,
            type: 'image',
            page_url: decoder(searchParams.get('page_url') as string)
          }}
        />
      </Col>
    </Row>
  );
};

export default Img;
